import script from "./App.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue.scss?vue&type=style&index=0&id=3e4c3123&lang=scss!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=style&index=0&id=3e4c3123&lang=scss"

const __exports__ = script;

export default __exports__